import React, {useState, useEffect} from "react";
import orbita from '../assets/images/orbita.svg'

const Beneficios = () => {

  const texts = [
    "Atención personalizada",
    "Rápida entrega de datos",
    "Visualización de métricas centralizadas",
    "Contacto directo con Cencosud",
    "Reportería 360°"
  ];
  const desc = [
    "Tendremos un equipo dedicado para resolver tus consultas y dudas de la plataforma",
    "Datos a primera hora del día, y si lo necesitas, también en tiempo real",
    "Única fuente de datos y KPI de gestión para los equipos internos y proveedores",
    "Nuevo ROL Kam Comercial que facilitara y orquestara la comunicación directa con nuestras áreas",
    "Obtiene una mirada transversal de los principales datos y KPI para cada proceso de negocio"
  ];

  return (
    <div className="component beneficios-component" id="Beneficios">
      
        <div className="orbita" data-aos="fade-down" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-offset="0" data-aos-delay="400">
          <img src={orbita} width="100%" />
          <div className="sat"><span></span></div>
        </div>
        
          <div className="mid">
            <h2>¿En qué te puedo ayudar?</h2>
            <p>Descubre los beneficios de ser partners usando el DataSharing a tu favor</p>
            <a href="#">Conoce Datasharing ahora <span className="material-symbols-outlined">arrow_outward</span></a>
          </div>
          <div className="mid">&nbsp;</div>
        

        <div className="float-txt ft1" data-aos="fade-in" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-offset="0" data-aos-delay="1600">{ texts[0] }<span>{ desc[0] }</span></div>
        <div className="float-txt ft2" data-aos="fade-in" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-offset="0" data-aos-delay="2400">{ texts[1] }<span>{ desc[1] }</span></div>
        <div className="float-txt ft3" data-aos="fade-in" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-offset="0" data-aos-delay="2000">{ texts[2] }<span>{ desc[2] }</span></div>
        <div className="float-txt ft4" data-aos="fade-in" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-offset="0" data-aos-delay="600">{ texts[3] }<span>{ desc[3] }</span></div>
        <div className="float-txt ft5" data-aos="fade-in" data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-offset="0" data-aos-delay="2800">{ texts[4] }<span>{ desc[4] }</span></div>
      
    </div>
  );
};

export default Beneficios;